/**
 * @generated SignedSource<<09b197aabd9691032819fdf540dc8d43>>
 * @relayHash 52789631eca828daaf15467fad025a41
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52789631eca828daaf15467fad025a41

import { ConcreteRequest, Query } from 'relay-runtime';
export type FourOhFourQuery$variables = {};
export type FourOhFourQuery$data = {
  readonly me: {
    readonly displayName: string;
  };
};
export type FourOhFourQuery = {
  response: FourOhFourQuery$data;
  variables: FourOhFourQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FourOhFourQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FourOhFourQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "52789631eca828daaf15467fad025a41",
    "metadata": {},
    "name": "FourOhFourQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2737763deeb5ca8cfa538574a8f60953";

export default node;
